import React from 'react';
import { NextImage } from '../../../atoms/image/image';
import { Link } from './Link';
import { portal } from '../../../../utils/locale';
import { getAssetsPrefix } from '../../../../utils/buildVersion';
import styled from '@emotion/styled';

const styles: any = {
    logoLink: {
        display: 'inline-block',
        maxWidth: '195px',
    },
};

const LogoWrapper = styled.div`
    display: flex;
    padding-right: 10px;
    height: 42px;
`;

const assetPrefix = getAssetsPrefix();
export const Logo = ({ isMobile }: { isMobile: boolean }) => {
    const logoImage = isMobile ? `${portal}_mobile.svg` : `${portal}.svg`;
    return (
        <LogoWrapper>
            <Link href="/" style={styles.logoLink}>
                <NextImage
                    alt="Dreamlines logo"
                    imgUrl={`${assetPrefix}/static/images/logos/${logoImage}`}
                    width={100}
                    height={42}
                    isBackground={false}
                    placeholder="Dreamlines logo"
                />
            </Link>
        </LogoWrapper>
    );
};
